import ReactInputMask from "react-input-mask";
import styled, { css } from "styled-components";

export const InpuWrapError = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

type ContainerProps = {
  withIcon: boolean;
  whitError: boolean;
  disabled: boolean;
};

export const Container = styled.div<ContainerProps>`
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 3px;
  height: 56px;
  width: 100%;
  position: relative;
  background: #ffff;

  padding: 12px;
  transition: all 0.2s;

  ${({ disabled }) =>
    disabled &&
    css`
      background: #f4f7f7;
    `}

  ${({ withIcon }) =>
    withIcon &&
    css`
      padding-left: 52px;
    `}

  svg {
    position: absolute;
    top: 12px;
    left: 12px;

    &.iconPass {
      right: 12px !important;
      left: unset;
      cursor: pointer;
    }
  }

  ${({ whitError }) =>
    whitError &&
    css`
      color: #dc3545;
      border: 1px solid #dc3545;
    `}
`;

export const Input = styled.input`
  border: none;
  background: transparent;
  outline: none !important;
  position: relative;
  z-index: 2;
  margin-top: 6px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  color: #7a7a7a;
  width: 90%;
`;

export const InputMask = styled(ReactInputMask)`
  border: none;
  background: transparent;
  outline: none !important;
  position: relative;
  z-index: 2;
  margin-top: 6px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  color: #7a7a7a;
  width: 90%;
`;

type LabelProps = {
  isFocus: boolean;
};

export const Label = styled.label<LabelProps>`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  display: flex;
  align-items: center;
  color: #c1c1c1;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  z-index: 1;

  transform: translate(6px, 6px) scale(1);
  transform-origin: top left;

  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  ${({ isFocus }) =>
    isFocus &&
    css`
      transform: translate(0, -6px) scale(0.75);
      transform-origin: top left;
    `}
`;
export const Helper = styled.span`
  color: #6b6b6b;
  font-size: 14px;
  line-height: 20px;
  margin-top: 4px;
`;

export const Error = styled.span`
  color: #dc3545;
`;
